import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@projeccions-pdc/react-icon';
import LocalizedStrings from '../../Localization/localization';
import NotificationAttachment from '../../Common/NotificationAttachment';
import './NotificationDetails.css';

class NotificationDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pendingDelete: false,
        };
    }

    // async componentWillReceiveProps(nextProps) {
    //     this.setState({ pendingDelete: false });
    // }

    handleDelete = () => {
        this.setState({ pendingDelete: true });
    };

    handleDeleteConfirmation = () => {
        this.setState({ pendingDelete: false });
        this.props.onDelete(this.props.notification.messageId);
    };

    handleDeleteCancel = () => {
        this.setState({ pendingDelete: false });
    };

    handleOpenResource = (resource, evt) => {
        if (resource.resourceType === 'file') {
            this.props.openFileViewer(
                //TODO: Review this shit!!
                //resource.resourceId,
                resource.resourceId.indexOf('~') === -1 ? resource.resourceId : resource.resourceId.split('~')[1],
                resource.resourceSubtype
            );
        } else if (resource.resourceType === 'content') {
            this.props.openContent(
                //TODO: Review this shit!!
                //resource.resourceId,
                resource.resourceId.indexOf('~') === -1 ? resource.resourceId : resource.resourceId.split('~')[1],
                resource.resourceSubtype,
                'show',
                evt
            );
        } else {
            console.log('Implement open callback');
            //TODO: implement actions to open everything
        }
    };

    handleClickLink = (evt) => {
        if (evt.target.tagName === 'A') {
            evt.preventDefault();
            let url = evt.target.href;
            this.props.onOpenLink(url);
        }
    };

    render() {
        if (!this.props.notification) {
            return <div className="notification-content notification-content-empty">{LocalizedStrings.chooseNotification}</div>;
        }

        const date = new Date(this.props.notification.dateCreated).toLocaleString();

        const getDeleteButton = () => {
            if (this.state.pendingDelete) {
                return (
                    <div className="delete-btn">
                        <IconButton name={'fa-check'} padding={5} primaryColor="#333" onClick={this.handleDeleteConfirmation} />
                        {'  '}
                        <IconButton name={'fa-close'} padding={5} primaryColor="#333" onClick={this.handleDeleteCancel} />
                    </div>
                );
            } else {
                return (
                    <div className="delete-btn">
                        <IconButton name={'fa-trash'} padding={5} primaryColor="#fff" secondaryColor="#f00" onClick={this.handleDelete} />
                    </div>
                    // <DeleteIcon onClick={this.handleDelete} className='delete-btn' />
                );
            }
        };
        return (
            <div className={`notification-content ${this.props.isSmartphone === true ? 'smartphone' : ''}`}>
                <div className="notification-content__header">
                    <h3 className="notification-content__subject">
                        {this.props.isSmartphone === true && (
                            <IconButton name={'md-arrow-back'} padding={5} primaryColor="#333" onClick={this.props.onCloseNotification} />
                        )}
                        {this.props.notification.title}
                    </h3>
                    {getDeleteButton()}
                    <div className="notification-content__time">{date}</div>
                    {/* <div className='notification-content__from'>{notification.from}</div> */}
                </div>
                <div className="notification-content__message">
                    <div
                        onClick={this.handleClickLink}
                        dangerouslySetInnerHTML={{
                            __html: this.props.notification.content,
                        }}
                    />
                    <div>
                        {this.props.notification.attachments.map((attachment) => {
                            return (
                                <NotificationAttachment
                                    key={attachment.resourceId}
                                    resource={attachment}
                                    onItemClick={this.handleOpenResource}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
NotificationDetails.propTypes = {
    notification: PropTypes.object,
    onDelete: PropTypes.func.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
    isSmartphone: PropTypes.bool.isRequired,
    onCloseNotification: PropTypes.func.isRequired,
    onOpenLink: PropTypes.func.isRequired,
};

export default NotificationDetails;
